<div class="event-checkout-dialog">
    <div class="text-right pr-20">
        <i class="fa fa-times pointer" aria-hidden="true" (click)="closeModal()"></i>
    </div>
    <h1 class="text-center ff">PAYMENT NOTICE</h1>
    <div class="modal-body text-center">
        <p class="fs-18 fw-400 modal-text ff lh-28">We were unable to process your last payment.Please update your
            payment information to continue your subscription plan.</p>

        <button mat-flat-button class="flat-primary-button border-radius-5 ml-20 m-t-10"
            (click)="updatePayment()">Update Payment</button>
    </div>
</div>